// extracted by mini-css-extract-plugin
module.exports = {"c93kv52":"c93kv52","scev1do":"scev1do"};